export const CLONE_CONTENT = 'CLONE_CONTENT';

export const cloneContent = value => ({ type: CLONE_CONTENT, value });

export const CONTENT_WAS_CLONED = 'CONTENT_WAS_CLONED';

export const contentWasCloned = value => ({ type: CONTENT_WAS_CLONED, value });
